module.exports = __webpack_public_path__ + "thumbnail-f864834dd3a00def5f2cf572017dfa04.png";